// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".welcome-bonus[data-v-3b171e57]{display:flex;grid-gap:var(--spaces-s);align-items:center;padding:var(--padding-xs) var(--padding-m);background-color:var(--general-bg-card);border-radius:var(--radius-l)}.welcome-bonus__image[data-v-3b171e57]{width:56px;height:56px}.welcome-bonus__button[data-v-3b171e57]{margin-left:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
